module.exports = __webpack_public_path__ + "images/0b04842ee5b49e71e4c8238446505297.jpg";